module.exports = __webpack_public_path__ + "img/T2B_xs_01.5c0531f4.png";